module.exports = __webpack_public_path__ + "img/404.7cc7976.png";